<script>
import InputSelect from '../node-landing-generique/InputSelect.vue'
import PageLandingLivreBlanc from '../node-landing-livre-blanc/PageLandingLivreBlanc.vue'

export default {
  name: 'PageLBChangerFournisseur',

  extends: PageLandingLivreBlanc,

  components: {
    InputSelect,
  },

  data() {
    return {
      selects: {
        business_sector: [
          'Industrie',
          'Immobilier',
          'Collectivités locales',
          'Agriculture',
          'Copropriété',
          'Hôtel / Restaurant',
          'Commerce',
          'Garage',
          'TPE/PME',
          'EHPAD',
          'Autre secteur',
        ],
      },
      form: {
        business_sector: '',
        zipcode: '',
        lastname: '',
        firstname: '',
        phone: '',
        email: '',
        company_name: '',
        captcha: '',
        mention: '',
        specify_your_request: '',
      },
      formEl: null,
      isPosted: false,
      captchaError: false,
    }
  },

  props: {
    optin: {
      type: String,
      default: '',
    },
  },

  methods: {
    updateDatalayer(formData) {
      window.dataLayer.push({
        event: 'form_confirmation',
        ...formData,
      })
    },

    onCaptchaExpired() {
      this.$refs.recaptcha.reset()
      this.captchaError = true
    },

    onCaptchaVerified(token) {
      this.$refs.recaptcha.reset()
      this.form.captcha = token
      this.submitForm()
    },

    checkRecaptcha() {
      this.captchaError = false
      this.$refs.recaptcha.execute()
    },

    submitForm() {
      this.$validator
        .validateAll()
        .then((result) => {
          if (result && this.form.captcha.length > 0) {
            this.sendForm()
          }
        })
        .catch((e) => {
          console.error(e)
        })
    },

    sendForm() {
      const formData = {
        event: 'form_confirmation',
        form_type: 'Livre_blanc',
        form_name: this.$el
          .querySelector('#form .title.title--2')
          .textContent.replace(/\s\s+/g, ' ')
          .replace(/["+?!]/g, '')
          .replace(/[#_', ]/g, '_')
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, ''),
      }

      for (let [key, value] of Object.entries(this.form)) {
        let input = this.formEl.querySelector(`[name='${key.toLowerCase()}']`)

        if (input) {
          switch (key) {
            case 'mention':
              input.value = value ? this.optin : ''
              break
            case 'acceptance':
              input.value = 'Envoyer mon email'
              break
            default:
              input.value = value
              break
          }
        }
      }

      // Datalayer
      this.updateDatalayer(formData)
      this.formEl.submit()
    },

    pushToDataLayer(event) {
      if (event) {
        window.dataLayer.push({
          event: 'click',
          click: event.target.textContent
            .replace(/\s\s+/g, ' ')
            .replace(/["+?!]/g, '')
            .replace(/[#_', ]/g, '_')
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, ''),
          click_type: 'navigation',
          event_location: 'content',
        })
      }
    },
  },

  created() {
    this.$validator.localize('fr', {
      attributes: {
        lastname: 'nom ',
        firstname: 'prénom',
        company_name: 'société',
        phone: 'téléphone',
        email: 'email',
      },
    })
  },

  mounted() {
    window.dataLayer = window.dataLayer || []

    this.formEl = this.$el.querySelector('form')
    this.isPosted = this.formEl.querySelector('.webform-confirmation') !== null

    const itemToPush = {}
    const H1 = document.querySelector('h1')

    if (H1) {
      itemToPush['pagename'] = H1.textContent
        .replace(/\s\s+/g, ' ')
        .replace(/["+?!]/g, '')
        .replace(/[#_', ]/g, '_')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
    }

    itemToPush['pagetype'] = 'Landing page'
    itemToPush['event'] = 'page_load'

    window.dataLayer.push(itemToPush)
  },
}
</script>

<style scoped lang="sass">
@import ../node-landing-livre-blanc/LandingLivreBlanc

.wrapper
  .summary
    flex-direction: column
    flex-wrap: nowrap

.lb_bg_fournisseur
  top: 0!important
  right: 0!important

</style>
